import { Box, Grid, Button, Typography, Tooltip, Stack } from "@mui/material";
import { ReactComponent as AddIcon } from "../../../assets/icons/MedintAddIcon.svg";
import { ReactComponent as PrestazioniAbbinateIcon } from "../../../assets/icons/PrestazioniAbbinate.svg";
import BinIcon from "../../../assets/icons/RedTrashBin.svg";
import { useContext, useEffect, useMemo, useState } from "react";
import RecurringBookingTable from "../RecurringBookingTable/RecurringBookingTable";
import { FormProvider, UseFormReturn } from "react-hook-form";
import RecurringBookingFormInterface, {
  RecurringBookingDataGenerated,
} from "../../../services/recurringBookingInterfaces";
import { RecurringBookingContext } from "../Context/RecurringBookingContextWrapper";
import {
  doctor,
  performance,
  specialities,
  typology,
} from "../../../networking";
import { PosizioniTicketByTipologia } from "../../../services/interfaces";
import { PosizioneTicket } from "../../AppointmentManagement/AppointmentManagement";
import {
  RHFAutocomplete,
  RHFDateTimePicker,
  RHFTextField,
  RHFTimePicker,
} from "../../RHFComponents/RHFComponents";
import PairedServices from "./PairedServices";

type TicketOption = PosizioneTicket | PosizioniTicketByTipologia;

let __prestazioniAllCache: any[] | null = null;

const RecurringBookingFormDetail = (props: {
  handleRemoveTab: Function;
  handleAddTab: Function;
  id: number;
  tabs: number[];
  methods: UseFormReturn<RecurringBookingFormInterface>;
  pianoAppuntamenti?: RecurringBookingDataGenerated[] | null;
}) => {
  const context = useContext(RecurringBookingContext);

  const [dottoriMEDICIPRE, setDottoriMEDICIPRE] = useState<any>(null);
  const [typologiesTIPOLOGIE, setTypologiesTIPOLOGIE] = useState<any>(null);
  const [specialitiesSPECIALITA, setSpecialitiesSPECIALITA] =
    useState<any>(null);
  const [performancePRESTAZIONI, setPerformacePRESTAZIONI] =
    useState<any>(null);
  // prestazioni complete solo per il modale
  const [prestazioniALL, setPrestazioniALL] = useState<any[] | null>(null);
  let performancesAllController: AbortController | null = null;
  const [abbinaAttivo, setAbbinaAttivo] = useState(false);

  // lista controllers per interrompere api
  let doctorsController: AbortController | null = null;
  let performancesController: AbortController | null = null;
  let tipologiesController: AbortController | null = null;
  let specialitiesController: AbortController | null = null;

  async function requestTypologiesTIPOLOGIA() {
    if (tipologiesController) {
      tipologiesController.abort();
    }
    tipologiesController = new AbortController();

    try {
      const response = await typology(
        {
          tipoAgenda: "",
          listino: "",
          specialita: watchSpecialita?.SPECIALITA ?? "",
          prestazione: watchPrestazione?.PRESTAZIONE ?? "",
          medico: [watchMedico?.CODICE],
        },
        tipologiesController.signal
      );
      const typologiesList = response.data.dati;
      console.log({ typologiesList });
      setTypologiesTIPOLOGIE(typologiesList);
    } catch (error) {
      console.error("Error fetching tipologie agenda:", error);
    }
  }

  async function requestSpecialitiesListSPECIALITA() {
    if (specialitiesController) {
      specialitiesController.abort();
    }
    specialitiesController = new AbortController();

    try {
      const data = await specialities(
        {
          tipoAgenda: watchTipologiaAgenda?.CODICE ?? "",
          listino: "",
          specialita: "",
          prestazione: watchPrestazione?.PRESTAZIONE ?? "",
          medico: [watchMedico?.CODICE],
        },
        specialitiesController.signal
      );
      const specialitiesList = data.data.dati;
      console.log({ specialitiesList });
      setSpecialitiesSPECIALITA(specialitiesList);
    } catch (error) {
      console.error("Error fetching specialita:", error);
    }
  }

  async function requestPerformancePRESTAZIONI() {
    if (performancesController) {
      performancesController.abort();
    }
    performancesController = new AbortController();

    try {
      const data = await performance(
        {
          tipoAgenda: watchTipologiaAgenda?.CODICE ?? "",
          listino: "",
          specialita: watchSpecialita?.SPECIALITA ?? "",
          prestazione: "",
          medico: [watchMedico?.CODICE],
        },
        performancesController.signal
      );
      const performancesList = data.data.dati;
      console.log({ performancesList });
      setPerformacePRESTAZIONI(performancesList);
    } catch (error) {
      console.error("Error fetching prestazioni:", error);
    }
  }

  async function requestPerformanceALL() {
    if (__prestazioniAllCache) {
      setPrestazioniALL(__prestazioniAllCache);
      return;
    }
    if (performancesAllController) performancesAllController.abort();
    performancesAllController = new AbortController();
    try {
      const { data } = await performance(
        {
          tipoAgenda: "",
          listino: "",
          specialita: "",
          prestazione: "",
          medico: [],
        },
        performancesAllController.signal
      );
      __prestazioniAllCache = data?.dati ?? [];
      setPrestazioniALL(__prestazioniAllCache);
    } catch (error) {
      console.error("Error fetching prestazioni ALL:", error);
    }
  }

  async function requestDottoriMEDICIPRE() {
    if (doctorsController) {
      doctorsController.abort();
    }
    doctorsController = new AbortController();

    try {
      const data = await doctor(
        {
          tipoAgenda: watchTipologiaAgenda?.CODICE ?? "",
          listino: "",
          specialita: watchSpecialita?.SPECIALITA ?? "",
          prestazione: watchPrestazione?.PRESTAZIONE ?? "",
          medico: "",
        },
        doctorsController.signal
      );
      const doctorsList = data.data.dati;
      console.log({ doctorsList });
      setDottoriMEDICIPRE(doctorsList);
    } catch (error) {
      console.error("Error fetching dottori:", error);
    }
  }

  const watchSpecialita = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.specialita`
  );
  const watchPrestazione = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.prestazione`
  );
  const watchTipologiaAgenda = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.tipologiaAgenda`
  );
  const watchMedico: any = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.medico`
  );
  const watchNumeroCicli = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.numeroCicli`
  );
  const watchDurata = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.durata`
  );
  const watchOraPrestazione = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.oraPrestazione`
  );
  const watchDistretto = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.distretto`
  );
  const watchTicket: any = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.ticket`
  );
  const watchEnte: any = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.ente`
  );

  const watchPrestazioneAbbinata: any = props.methods.watch(
    `recurringBooking.istanzaSchedaDettaglio.${props.id}.prestazioneAbbinata`
  );

  useEffect(() => {
    requestDottoriMEDICIPRE();
    requestPerformancePRESTAZIONI();
    requestSpecialitiesListSPECIALITA();
    requestTypologiesTIPOLOGIA();
  }, [
    watchSpecialita,
    watchPrestazione,
    watchTipologiaAgenda,
    watchMedico,
    watchTicket,
  ]);

  useEffect(() => {
    props.methods.setValue(
      `recurringBooking.istanzaSchedaDettaglio.${props.id}.numeroCicli`,
      watchPrestazione?.QUANTITA ?? ""
    );
  }, [watchPrestazione]);

  useEffect(() => {
    if (
      context?.confermaPianoTerapiaBody?.prestazioni &&
      typeof props.id === "number"
    ) {
      const progressivo = String(props.id + 1);

      // Trova la prestazione corrispondente al progressivo
      const selectedProgressivo = (context?.selectedAppointments ?? []).find(
        (a) => a.PROGRESSIVOPRESTAZIONE === progressivo
      );

      context?.setConfermaPianoTerapiaBody((prev: any) => {
        const newPrestazioni = [...prev.prestazioni];

        newPrestazioni[props.id] = {
          ...newPrestazioni[props.id],
          specialita: watchSpecialita?.SPECIALITA ?? "",
          prestazione: watchPrestazione?.PRESTAZIONE ?? "",
          tipologia: watchTipologiaAgenda?.CODICE ?? "",
          progressivoPrestazione: String(props.id + 1),
          idPrestazione: selectedProgressivo?.IDPRESTAZIONE ?? "", //in base al progressivo inserisco l'ID della prestazione
          idTipoPrest: "",
          impegnativa: "",
          dataImpegnativa: "",
          IUP: "",
          diagnosi: "",
          notePrestazione: "",
          primoAccesso: "",
          PIC: "",
          IDPai: "",
          tollGGAttesa: "",
          approfondimento: "",
          protPIC: "",
          classePriorita: "",
          tipoRicetta: "",
          suggerita: "",
          IURP: "",
          provenienzaPaziente: "",
          esenzione: "",
          codPrestSISS: "",
          codAgendaGP: "",
          codNomenclRegionale: "",
          codCatalogoPrescr: "",
          prescrittore: "",
        };

        return {
          ...prev,
          prestazioni: newPrestazioni,
        };
      });
    }
  }, [
    watchSpecialita,
    watchPrestazione,
    watchTipologiaAgenda,
    watchMedico,
    context?.selectedAppointments,
  ]);

  useEffect(() => {
    props.methods.setValue(
      `recurringBooking.istanzaSchedaDettaglio.${props.id}.ticket`,
      context?.posizioniTicketRicerca?.find(
        (e) => e?.codice === watchEnte?.codicepostic
      )
    );
  }, [watchEnte]);

  const getOptionLabelTicket = (option: TicketOption) => {
    if ("RICERCAPOSTIC" in option) {
      return option.RICERCAPOSTIC || "";
    }
    return option.descrizione || "";
  };

  const isOptionEqualToValueTicket = (
    a: TicketOption,
    b?: TicketOption | null
  ) =>
    b
      ? "RICERCAPOSTIC" in a
        ? a.CODICEPOSTIC === (b as any)?.CODICEPOSTIC
        : (a as any).codice === (b as any)?.codice
      : false;

  useEffect(() => {
    const firstValue = watchTipologiaAgenda?.posizioniTicket?.find(
      (e) => e.SELEZIONATO === "1"
    );
    if (firstValue)
      props.methods.setValue(
        `recurringBooking.istanzaSchedaDettaglio.${props.id}.ticket`,
        firstValue
      );
  }, [watchTipologiaAgenda]);

  useEffect(() => {
    if (
      Array.isArray(specialitiesSPECIALITA) &&
      specialitiesSPECIALITA.length === 1
    ) {
      const value = specialitiesSPECIALITA[0];
      const currentValue = props.methods.getValues(
        `recurringBooking.istanzaSchedaDettaglio.${props.id}.specialita`
      );

      if (currentValue?.DESCRIZIONE !== value.DESCRIZIONE) {
        props.methods.setValue(
          `recurringBooking.istanzaSchedaDettaglio.${props.id}.specialita`,
          value,
          { shouldValidate: true }
        );
      }
    }
  }, [specialitiesSPECIALITA]);

  const normalizeAppuntamenti = (appuntamenti: any) => {
    if (!appuntamenti) return [];
    return Array.isArray(appuntamenti) ? appuntamenti : [appuntamenti];
  };

  const appuntamenti = normalizeAppuntamenti(props.pianoAppuntamenti);

  // Controlla se la prestazione abbinata è valorizzata, in modo da gestire il colore del button
  const isPairedSelected =
    !!watchPrestazioneAbbinata?.PRESTAZIONE ||
    (!!watchPrestazioneAbbinata &&
      typeof watchPrestazioneAbbinata === "object" &&
      Object.keys(watchPrestazioneAbbinata).length > 0);

  //Per abilitare/Disabilitare l'apertura del modale e chiamare l'api delle prestazioni per le abbinate
  const handleOpenPaired = async () => {
    if (!__prestazioniAllCache && !prestazioniALL) {
      await requestPerformanceALL();
    }
    setAbbinaAttivo(true);
  };
  const handleClosePaired = () => setAbbinaAttivo(false);

  const namePrefix = `recurringBooking.istanzaSchedaDettaglio.${props.id}`;

  //Helper per eliminare tutte le chiavi duplicate di mui (errori in console log sulle key)
  const performancePRESTAZIONI_UNIQ = useMemo(() => {
    const seen = new Set<string>();
    return (performancePRESTAZIONI ?? []).filter((p: any) => {
      const k = `${p?.PRESTAZIONE ?? ""}__${p?.SPECIALITA ?? ""}`;
      if (seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }, [performancePRESTAZIONI]);

  return (
    <>
      <FormProvider {...props.methods}>
        <Box
          p={2}
          border="1px solid #ccc"
          borderRadius={2}
          sx={{ backgroundColor: "#ffffff" }}
        >
          {/* Modale Prestazioni Abbinate */}
          <PairedServices
            key={`paired-${props.id}`}
            open={abbinaAttivo}
            onClose={handleClosePaired}
            onDelete={() => {
              props.methods.setValue(
                `recurringBooking.istanzaSchedaDettaglio.${props.id}.prestazioneAbbinata`,
                null,
                { shouldDirty: true, shouldValidate: true }
              );
            }}
            specialitaDisponibili={specialitiesSPECIALITA ?? []}
            prestazioniDisponibili={
              prestazioniALL ?? performancePRESTAZIONI ?? []
            }
            namePrefix={namePrefix}
          />

          <Grid container spacing={2}>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignContent: "center",
                alignItems: "center",
                paddingTop: 2,
              }}
            >
              <Grid item paddingLeft={2}>
                <Typography>{props.id + 1}</Typography>
              </Grid>
              <Grid item>
                <Stack direction="row" spacing={1}>
                  <Tooltip title="Rimuovi finestra">
                    <Button
                      sx={{
                        width: "fit-content",
                        minWidth: "unset",
                        "&:hover img": {
                          filter: "brightness(0) saturate(100%) invert(100%)",
                        },
                        visibility:
                          props.id + 1 === props.tabs.length &&
                          !(
                            Array.isArray(props.pianoAppuntamenti) &&
                            props.pianoAppuntamenti.length > 0
                          )
                            ? props.id + 1 !== 1
                              ? "visible"
                              : "hidden"
                            : "hidden",
                      }}
                      variant="outlinedError"
                      onClick={() => props.handleRemoveTab()}
                    >
                      <img src={BinIcon} alt="Elimina" width={20} height={20} />
                    </Button>
                  </Tooltip>
                  <Tooltip title="Aggiungi finestra">
                    <Button
                      sx={{
                        width: "fit-content",
                        minWidth: "unset",
                        visibility:
                          props.id + 1 === props.tabs.length &&
                          !(
                            Array.isArray(props.pianoAppuntamenti) &&
                            props.pianoAppuntamenti.length > 0
                          )
                            ? props.id + 1 !== 4
                              ? "visible"
                              : "hidden"
                            : "hidden",
                      }}
                      variant="contained"
                      onClick={() => props.handleAddTab()}
                    >
                      <AddIcon className="medintIcons2" />
                    </Button>
                  </Tooltip>
                </Stack>
              </Grid>
            </Grid>
            {/* Prima riga */}
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete
                keyField="SPECIALITA"
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.specialita`}
                control={props.methods.control}
                rules={{
                  required: "Campo obbligatorio",
                }}
                autoComplete
                autoHighlight
                componentsProps={{
                  clearIndicator: {
                    title: "Pulisci selezione",
                  },
                }}
                size="small"
                options={specialitiesSPECIALITA ?? []}
                getOptionLabel={(option) => option.DESCRIZIONE || ""}
                isOptionEqualToValue={(option, value) =>
                  option.SPECIALITA === value.SPECIALITA
                }
                fullWidth
                label="Specialità"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                      props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.prestazione`}
                keyField="DESCRIZIONE"
                control={props.methods.control}
                rules={{
                  required: "Campo obbligatorio",
                }}
                autoComplete
                autoHighlight
                componentsProps={{
                  clearIndicator: {
                    title: "Pulisci selezione",
                  },
                }}
                size="small"
                options={performancePRESTAZIONI_UNIQ ?? []}
                getOptionLabel={(option) => option.DESPRESTAZIONE || ""}
                isOptionEqualToValue={(option, value) =>
                  option.DESPRESTAZIONE === value.PRESTAZIONE
                }
                fullWidth
                label="Prestazione"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                      props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.prestazioneAbbinata`}
                keyField="PRESTAZIONEABBINATA"
                control={props.methods.control}
                autoComplete
                autoHighlight
                componentsProps={{
                  clearIndicator: {
                    title: "Pulisci selezione",
                  },
                }}
                size="small"
                options={performancePRESTAZIONI ?? []}
                getOptionLabel={(option) => option.DESPRESTAZIONE || ""}
                isOptionEqualToValue={(a: any, b: any) =>
                  !!b &&
                  a.PRESTAZIONE === b.PRESTAZIONE &&
                  a.SPECIALITA === b.SPECIALITA
                }
                fullWidth
                getOptionKey={(o: any) =>
                  `${o?.PRESTAZIONE ?? ""}__${o?.SPECIALITA ?? ""}`
                }
                label="Prestazione Abbinata"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.tipologiaAgenda`}
                keyField="TIPOAGENDA"
                control={props.methods.control}
                rules={{
                  required: "Campo obbligatorio",
                }}
                autoComplete
                autoHighlight
                componentsProps={{
                  clearIndicator: {
                    title: "Pulisci selezione",
                  },
                }}
                size="small"
                options={typologiesTIPOLOGIE ?? []}
                getOptionLabel={(option) => option.DESCRIZIONE || ""}
                isOptionEqualToValue={(option, value) =>
                  option.DESCRIZIONE === value.DESCRIZIONE
                }
                fullWidth
                label="Tipologia Agenda"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete
                fullWidth
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.medico`}
                keyField="MEDICO"
                control={props.methods.control}
                autoComplete
                autoHighlight
                componentsProps={{
                  clearIndicator: {
                    title: "Pulisci selezione",
                  },
                }}
                size="small"
                options={dottoriMEDICIPRE ?? []}
                getOptionLabel={(option: any) => option.CODDESCR || ""}
                isOptionEqualToValue={(option: any, value: any) =>
                  option.DESCRIZIONE === value.DESCRIZIONE
                }
                label="Medico/Risorsa"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>

            {/* Seconda riga */}
            <Grid item xs={12} sm={6} md={4}>
              <RHFTextField
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.numeroCicli`}
                control={props.methods.control}
                size="small"
                fullWidth
                required
                placeholder="max 360"
                label="Numero Cicli"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <RHFTextField
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.durata`}
                control={props.methods.control}
                size="small"
                fullWidth
                label="Durata"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <RHFTimePicker
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.oraPrestazione`}
                control={props.methods.control}
                label="Ora Prestazione"
                size="small"
                fullWidth
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={2}
              display={"flex"}
              alignItems={"center"}
            >
              <Tooltip title="Abbina Prestazione" arrow disableInteractive>
                  <Button
                    variant={
                      isPairedSelected
                        ? "prestazioniToggleActive"
                        : "prestazioniToggle"
                    }
                    aria-pressed={isPairedSelected}
                    onClick={handleOpenPaired}
                    fullWidth
                    disabled={
                      Array.isArray(props.pianoAppuntamenti) &&
                      props.pianoAppuntamenti.length > 0
                    }
                    sx={{ width: "100%", height: "100%" }}
                  >
                    <PrestazioniAbbinateIcon className="medintIcons" />
                  </Button>
              </Tooltip>
            </Grid>

            <Grid item xs={12} sm={6} md={2.4}>
              <RHFTextField
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.distretto`}
                control={props.methods.control}
                label="Distretto"
                fullWidth
                size="small"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFTextField
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.codiceImpegnativa`}
                control={props.methods.control}
                size="small"
                fullWidth
                label="Codice Impegnativa"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFDateTimePicker
                dateOnly
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.dataImpegnativa`}
                control={props.methods.control}
                size="small"
                fullWidth
                label="Data Impegnativa"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>

            {/* Terza riga */}
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete<RecurringBookingFormInterface, TicketOption>
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.ticket`}
                keyField="TICKET"
                control={props.methods.control}
                rules={{
                  required: "Campo obbligatorio",
                }}
                autoComplete
                autoHighlight
                size="small"
                options={
                  (watchTipologiaAgenda?.posizioniTicket ?? []).length > 0
                    ? watchTipologiaAgenda?.posizioniTicket
                    : context?.posizioniTicketRicerca?.find(
                        (e) => e?.codice === watchTipologiaAgenda?.CODICE
                      ) ??
                      context?.posizioniTicketRicerca ??
                      []
                }
                getOptionLabel={getOptionLabelTicket}
                isOptionEqualToValue={isOptionEqualToValueTicket}
                label="Ticket"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4}>
              <RHFAutocomplete
                name={`recurringBooking.istanzaSchedaDettaglio.${props.id}.ente`}
                keyField="ENTE"
                control={props.methods.control}
                autoComplete
                autoHighlight
                size="small"
                options={context?.entiRicerca ?? []}
                getOptionLabel={(option) => option["ragione sociale"] || ""}
                isOptionEqualToValue={(option, value) =>
                  option["ragione sociale"] === value["ragione sociale"]
                }
                label="Ente"
                disabled={
                  Array.isArray(props.pianoAppuntamenti) &&
                  props.pianoAppuntamenti.length > 0
                }
              />
            </Grid>
          </Grid>
        </Box>
        {appuntamenti.length > 0 && (
          <RecurringBookingTable
            id={props.id + 1}
            pianoAppuntamenti={appuntamenti}
            SPECIALITA={
              watchSpecialita?.DESCRIZIONE || watchSpecialita?.SPECIALITA
            }
            PRESTAZIONE={
              watchPrestazione?.DESCRIZIONE || watchPrestazione?.PRESTAZIONE
            }
          />
        )}
      </FormProvider>
    </>
  );
};

export default RecurringBookingFormDetail;
